import { combineReducers } from 'redux';

import river from './river';
import rivers from './rivers';
import riverlist from './riverlist';
import selectedRivers from './selectedRivers';
import auth from './auth';

export const reducers = combineReducers({ auth, river, rivers, riverlist, selectedRivers });
